import { createContext } from "react";

export type PendingDashboardCustomizationAction = () => void | Promise<void>;

export interface DashboardCustomizationContextValue {
    setHasUnsavedChanges: (hasUnsavedChanges: boolean) => void;
    requestDiscardConfirmation: (action: PendingDashboardCustomizationAction) => void;
}

export const DashboardCustomizationContext =
    createContext<DashboardCustomizationContextValue | null>(null);
